// extracted by mini-css-extract-plugin
export default {"flexContainer":"UserEntry_flexContainer__ThHcv","flexItemRight":"UserEntry_flexItemRight__tP+Bs"};